import { getCurrentInstance, computed } from "vue";
const NOT_PROVIDED = Symbol("NOT_PROVIDED");
const useUserProvidedProp = (propName, props) => {
  const vm = getCurrentInstance();
  return computed(() => {
    if (!(vm == null ? void 0 : vm.vnode.props)) {
      return NOT_PROVIDED;
    }
    const originalProp = props[propName];
    return propName in vm.vnode.props ? originalProp : NOT_PROVIDED;
  });
};
export {
  NOT_PROVIDED as N,
  useUserProvidedProp as u
};
//# sourceMappingURL=useUserProvidedProp.js.map
